const Created = "created";
const Requested = "requested";
const Paid = "paid";
const Invalid = "invalid";

function all(): string[] {
  return [Created, Requested, Paid, Invalid];
}

export default {
  Created,
  Requested,
  Paid,
  Invalid,
  all
};
